import {
  ENTITY__COMPANY,
  ENTITY__SCHOOL
} from '../../../../../dictionaries/Entities.dic';
import {
  Arr
} from '../../../../../lib/Array.lib';
import {
  NOT,
  YES
} from '../../../../../lib/Boolean.lib';
import Core from '../../../../../lib/Core';
import globalErrorHandler from '../../../../../lib/Error/globalErrorHandler.fun';
import useState from '../../../../../lib/hooks/useState.hook';
import {
  Obj
} from '../../../../../lib/Object.lib';
import {
  COLLECTION__COMPANY,
  COLLECTION__SCHOOL,
  readLoopbackRecord
} from '../../../../../lib/services/BE/loopback.api';
import {
  joinKeyName
} from '../../../../../lib/String.lib';
import Box from '../../../../Layout/Wrappers/Box';
import Chip from '../../../../Layout/Wrappers/Chip';
import Fieldset from '../../../../Layout/Wrappers/Fieldset';
import IconButton from '../../../../Layout/Wrappers/IconButton';
import Message from '../../../../Layout/Wrappers/Message';
import Once from '../../../../Layout/Wrappers/Once';
import TaggedValue from '../../../../Layout/Wrappers/TaggedValue';
import Title from '../../../../Layout/Wrappers/Title';
import {
  getControllerJobEdit
} from '../../JobEdit';
import openDialogTargetAvoidPreferences from './openDialogTargetAvoidPreferences.fun';

export const KEY__CONTROLLER__SECTION__TARGET_AVOID_PREFERENCES = 'sectionTargetAvoidPreferences';

export function setControllerSectionTargetAvoidPreferences(controller) {
  return Core.setKeyValue(KEY__CONTROLLER__SECTION__TARGET_AVOID_PREFERENCES, controller);
}
export function getControllerSectionTargetAvoidPreferences() {
  return Obj(Core.getKeyValue(KEY__CONTROLLER__SECTION__TARGET_AVOID_PREFERENCES));
}

export default function SectionTargetAvoidPreferences({
  ...props
}) {

  const [state, updateState] = useState();

  const LIST__SCHOOLS_TARGET = Arr(state.schoolsTarget);
  const LIST__SCHOOLS_AVOID = Arr(state.schoolsAvoid);
  const LIST__COMPANIES_TARGET = Arr(state.companiesTarget);
  const LIST__COMPANIES_AVOID = Arr(state.companiesAvoid);

  const YES__SCHOOLS_TARGET_FOUND = YES(LIST__SCHOOLS_TARGET.length);
  const YES__SCHOOLS_AVOID_FOUND = YES(LIST__SCHOOLS_AVOID.length);
  const YES__COMPANIES_TARGET_FOUND = YES(LIST__COMPANIES_TARGET.length);
  const YES__COMPANIES_AVOID_FOUND = YES(LIST__COMPANIES_AVOID.length);

  const NOT__SCHOOLS_TARGET_FOUND = NOT(YES__SCHOOLS_TARGET_FOUND);
  const NOT__SCHOOLS_AVOID_FOUND = NOT(YES__SCHOOLS_AVOID_FOUND);
  const NOT__COMPANIES_TARGET_FOUND = NOT(YES__COMPANIES_TARGET_FOUND);
  const NOT__COMPANIES_AVOID_FOUND = NOT(YES__COMPANIES_AVOID_FOUND);

  const fetchData = async ({
    type = ENTITY__SCHOOL,
    subtype = 'target',
    ids = [],
  }) => {
    const YES__SCHOOL_TYPE = type === ENTITY__SCHOOL;
    try {
      const update = {
        [subtype]: Arr(
          ids.length &&
          await readLoopbackRecord({
            collection: YES__SCHOOL_TYPE ? COLLECTION__SCHOOL : COLLECTION__COMPANY,
            where: {
              id: { inq: ids }
            },
            order: [
              'name ASC',
              'universityName ASC',
              'crunchbaseOrganizationId DESC',
            ],
          })
        ).map((record) => ({
          ...record,
          LABEL: YES__SCHOOL_TYPE ? record.universityName : record.name
        }))
      };
      await updateState(update);
    }
    catch (error) {
      globalErrorHandler(error);
    }
  };

  const fetchPreferences = async () => {
    const jobPreferences = Obj(getControllerJobEdit().state?.jobPreferences);
    await fetchData({
      type: ENTITY__SCHOOL,
      subtype: 'schoolsTarget',
      ids: jobPreferences.schools?.target,
    });
    await fetchData({
      type: ENTITY__SCHOOL,
      subtype: 'schoolsAvoid',
      ids: jobPreferences.schools?.avoid,
    });
    await fetchData({
      type: ENTITY__COMPANY,
      subtype: 'companiesTarget',
      ids: jobPreferences.companies?.target,
    });
    await fetchData({
      type: ENTITY__COMPANY,
      subtype: 'companiesAvoid',
      ids: jobPreferences.companies?.avoid,
    });
  };

  setControllerSectionTargetAvoidPreferences({
    state,
    updateState,
    fetchData,
    fetchPreferences
  })

  return (
    <Box {...props}>

      <Box className='border rounded m-1 p-05'>

        <Box column className='bg-main rounded'>

          <Once
            acl={getControllerJobEdit().state?.id}
            promise={fetchPreferences}
          />

          <Title className='c-cyan-darker'>
            Add preferences
          </Title>

          <Fieldset
            title='Schools'
            wrapperProps={{ className: 'm-0' }}
            nextToTitle={
              <IconButton
                icon='add_circle'
                className='c-purple'
                onClick={(event) => {
                  openDialogTargetAvoidPreferences({
                    title: 'School preferences',
                    type: ENTITY__SCHOOL
                  })
                }}
              />
            }
          >
            <Box row
              acl={YES__SCHOOLS_TARGET_FOUND || YES__SCHOOLS_AVOID_FOUND}
              className='px-1 flex-align-left-top'
            >
              <ColumnPreferenceReadOnly
                context={{
                  TITLE: 'Target',
                  NOT__FOUND: NOT__SCHOOLS_TARGET_FOUND,
                  SPACENAME__TYPE: 'schools',
                  LIST: LIST__SCHOOLS_TARGET
                }}
                className='mr-1'
              />
              <ColumnPreferenceReadOnly
                context={{
                  TITLE: 'Avoid',
                  NOT__FOUND: NOT__SCHOOLS_AVOID_FOUND,
                  SPACENAME__TYPE: 'schools',
                  LIST: LIST__SCHOOLS_AVOID
                }}
              />
            </Box>
          </Fieldset>

          <Fieldset
            title='Companies'
            wrapperProps={{ className: 'm-0' }}
            nextToTitle={
              <IconButton
                icon='add_circle'
                className='c-purple'
                onClick={(event) => {
                  openDialogTargetAvoidPreferences({
                    title: 'Company preferences',
                    type: ENTITY__COMPANY
                  })
                }}
              />
            }
          >
            <Box row
              acl={YES__COMPANIES_TARGET_FOUND || YES__COMPANIES_AVOID_FOUND}
              className='px-1 flex-align-left-top'
            >
              <ColumnPreferenceReadOnly
                context={{
                  TITLE: 'Target',
                  NOT__FOUND: NOT__COMPANIES_TARGET_FOUND,
                  SPACENAME__TYPE: 'companies',
                  LIST: LIST__COMPANIES_TARGET
                }}
                className='mr-1'
              />
              <ColumnPreferenceReadOnly
                context={{
                  TITLE: 'Avoid',
                  NOT__FOUND: NOT__COMPANIES_AVOID_FOUND,
                  SPACENAME__TYPE: 'companies',
                  LIST: LIST__COMPANIES_AVOID
                }}
              />
            </Box>
          </Fieldset>

        </Box>


      </Box>

    </Box>
  );
}

export function ColumnPreferenceReadOnly({
  context = {},
  ...props
}) {
  const {
    TITLE = 'Target',
    NOT__FOUND = false,
    SPACENAME__TYPE = 'schools',
    LIST = []
  } = context;
  return (
    <TaggedValue
      tag={TITLE}
      value={
        <Box w100
          className='bg-white-lighter outlined rounded scroll p-1'
          style={{
            maxHeight: '18vh'
          }}
        >
          <Message show={NOT__FOUND}>
            No {SPACENAME__TYPE} set
          </Message>
          {LIST.map((
            record,
            index,
            array,
          ) => (
            <Chip
              key={joinKeyName([
                KEY__CONTROLLER__SECTION__TARGET_AVOID_PREFERENCES,
                'chip',
                TITLE,
                record.id,
                index
              ])}
              className='c-black-medium'
            >
              {record.LABEL}
            </Chip>
          ))}
        </Box>
      }
      {...props}
    />
  );
}
